import * as React from 'react';
import type { TFunctionalPerformanceMgravisDocumentType } from '../../utils';
import MGCForm from './MGC/index';
import { MGADLForm } from 'Routes/MyService/Document/Form/SurveyForms/MGADL';
import { useAppSelector } from 'Store/index';
import browserLanguage from 'Utility/browserLanguage';
import { formDataByType } from 'Utility/documentHandling';

const FunctionalPerformanceForm = ({ formData, document, viewing = false }: IOwnProps): React.JSX.Element | null => {
  const locale = useAppSelector(state => state.settings.userSettings.uiLanguage) ?? browserLanguage;

  switch (document?._type) {
    case 'mgc':
      return <MGCForm formData={formDataByType(formData, document)} viewing={viewing} />;
    case 'mgadl':
      return (
        <MGADLForm
          formData={formDataByType(formData, document)}
          editing={!viewing}
          viewing={viewing}
          locale={locale}
          clinicalForm={true}
        />
      );
    default:
      return null;
  }
};

interface IOwnProps {
  formData: IFormData<IDocumentWithTypeV2<TFunctionalPerformanceMgravisDocumentType>>;
  document?: IDocumentWithTypeV2<TFunctionalPerformanceMgravisDocumentType>;
  viewing?: boolean;
}

export default FunctionalPerformanceForm;
